import { useEffect, useState } from 'react';

/** 12/06/2026 02:00 GMT+7 = 11/06/2026 19:00 UTC — đồng bộ SC88 */
const TARGET_TIME = Date.UTC(2026, 6, 20, 2, 0, 0);

const LABELS = [
  { key: 'days', label: 'NGÀY' },
  { key: 'hours', label: 'GIỜ' },
  { key: 'minutes', label: 'PHÚT' },
  { key: 'seconds', label: 'GIÂY' }
];

const calculateTimeLeft = () => {
  const now = Date.now();
  const diff = TARGET_TIME - now;

  if (diff <= 0) {
    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
      finished: true
    };
  }

  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / (24 * 60 * 60));
  const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const pad = (n) => n.toString().padStart(2, '0');

  return {
    days: pad(days),
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    finished: false
  };
};

/**
 * Bốn ô đếm ngược — Figma:
 * - Mobile (< md): node 155-1207 — 40×40, bo 6px, gap 4px, số 18px, nhãn 10px
 * - md+: node 155-1206 — 64×64, bo 8px, gap 8px, số 28px, nhãn 12px
 * - Ô NGÀY: nền #F16522, chữ trắng — GIỜ/PHÚT/GIÂY: nền trắng, chữ #F16522
 */
const ORANGE = '#F16522';

const CountDownFinal = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  // if (timeLeft.finished) {
  //   return (
  //     <div
  //       className="inline-flex max-w-[min(100%,280px)] shrink-0 flex-col items-center justify-center rounded-[6px] border border-white/25 bg-white/95 px-2 py-1.5 md:max-w-none md:rounded-lg md:px-3 md:py-2"
  //       style={{
  //         fontFamily: 'Roboto, sans-serif',
  //         boxShadow:
  //           'inset 0 1px 0 rgba(255,255,255,0.6), 0 4px 12px rgba(11,133,199,0.15)'
  //       }}
  //     >
  //       <span className="text-center text-[10px] font-bold uppercase leading-tight tracking-wide text-[#F16522] md:text-xs md:leading-snug">
  //         Vòng chung kết đang diễn ra
  //       </span>
  //     </div>
  //   );
  // }

  const values = {
    days: timeLeft.days,
    hours: timeLeft.hours,
    minutes: timeLeft.minutes,
    seconds: timeLeft.seconds
  };

  return (
    <div
      className="flex shrink-0 items-center gap-1 md:gap-2"
      role="timer"
      aria-live="polite"
      aria-label="Đếm ngược đến World Cup 2026"
      style={{ fontFamily: 'Roboto, sans-serif' }}
    >
      {LABELS.map(({ key, label }) => {
        const isDays = key === 'days';
        return (
          <div
            key={key}
            className={
              isDays
                ? 'flex h-10 w-10 shrink-0 flex-col items-center justify-center rounded-[6px] text-center text-white shadow-[0_2px_6px_rgba(241,101,34,0.35)] md:h-16 md:w-16 md:rounded-lg md:shadow-[0_4px_10px_rgba(241,101,34,0.25)]'
                : 'flex h-10 w-10 shrink-0 flex-col items-center justify-center rounded-[6px] bg-white text-center text-[#F16522] md:h-16 md:w-16 md:rounded-lg'
            }
            style={isDays ? { backgroundColor: ORANGE } : undefined}
          >
            <span className="text-[18px] font-black leading-none tabular-nums md:text-[28px]">
              {values[key]}
            </span>
            <span className="mt-px text-[10px] font-bold uppercase leading-none tracking-[0.02em] md:mt-0.5 md:text-xs md:tracking-normal">
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default CountDownFinal;
